import Vendor from './Vendor.js';
export default Vendor;
